import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;



class ItemMaster {
  create = async (itemMaster: any) => {
    const res = await axios.post<any>(`${API_URL}item-master`, itemMaster)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
    return res.data;
  };

  edit = async (itemMaster: any, code: any) => {
    await axios.put<any>(`${API_URL}item-master/${code}`, itemMaster)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  editfromDashBoard = async (itemMaster: any, code: any) => {
    await axios.put<any>(`${API_URL}update-price/${code}`, itemMaster)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}item-master/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.item;
  };

  getAll = async (
      page?: number,
      perPage?: number,
      paginated?: boolean
    ) => {

    const params: any = {};

    if (paginated !== undefined) params.paginated = paginated;
    if (page !== undefined) params.page = page;
    if (perPage !== undefined) params.per_page = perPage;

    const response = await axios.get<any>(`${API_URL}item-master`, {
      params
    });

    return response.data.items;
  };



  search = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}item-master-search/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.item;
  };

  searchService = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}item-master-service-search/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.item;
  };

  posSearch = async (keyword: any, searchBy: any) => {
    const response = await axios.get<any>(`${API_URL}item-price-search-location/${keyword}`, {
      params: searchBy,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.stock;
  };

  posSearchWearHouse = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}item-price-search-warehouse-location/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.stock;
  };

  getLastBarcode = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}last-item-categoty/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data;
  };

  posSearchWithotStock = async (keyword: any, searchBy: any) => {
    const response = await axios.get<any>(`${API_URL}item-price-search-location-without-stock/${keyword}`, {
      params: searchBy,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.item;
  };
}

export default new ItemMaster();
